import { gRPCStatus } from "../api/grpc-status-codes";

export const grpcErrorToString: Record<number, string> = {
  [gRPCStatus.OK]: "Success",
  [gRPCStatus.CANCELLED]: "Cancelled",
  [gRPCStatus.UNKNOWN]: "Unknown error",
  [gRPCStatus.INVALID_ARGUMENT]: "Invalid argument",
  [gRPCStatus.DEADLINE_EXCEEDED]: "Deadline exceeded",
  [gRPCStatus.NOT_FOUND]: "Not found",
  [gRPCStatus.ALREADY_EXISTS]: "Already exists",
  [gRPCStatus.PERMISSION_DENIED]: "Permission denied",
  [gRPCStatus.RESOURCE_EXHAUSTED]: "Resource exhausted",
  [gRPCStatus.FAILED_PRECONDITION]: "Failed precondition",
  [gRPCStatus.OUT_OF_RANGE]: "Out of range",
  [gRPCStatus.UNIMPLEMENTED]: "Unimplemented",
  [gRPCStatus.INTERNAL]: "Internal error",
  [gRPCStatus.UNAVAILABLE]: "Unavailable",
  [gRPCStatus.ABORTED]: "Aborted",
  [gRPCStatus.DATA_LOSS]: "Data loss",
};
